export { App } from './App';


// WEBPACK FOOTER //
// ./src/components/App/index.js